import { z } from "zod";

export const addressSuggestionSchema = z.object({
  address: z.string(),
  postalCode: z.string().nullable(),
  municipality: z.string().nullable(),
  province: z.string().nullable(),
  provinceCode: z.string().nullable(),
  ccaa: z.string().nullable(),
});
export type AddressSuggestion = z.infer<typeof addressSuggestionSchema>;
